import React from 'react';
import { Skeleton as AntSkeleton, SkeletonProps as AntSkeletonProps } from 'antd';
import { createUseStyles } from 'react-jss';
import { ThemeType } from 'src/theming/jssTypes';

export interface SkeletonProps extends AntSkeletonProps {
  className?: string;
}

const useStyles = createUseStyles((theme: ThemeType) => ({
  skeleton: {
    '& .ant-skeleton-header .ant-skeleton-avatar': {
      backgroundColor: theme.color.semantic.background.neutral.soft,
    },
    '& .ant-skeleton-content .ant-skeleton-title': {
      backgroundColor: theme.color.semantic.background.neutral.soft,
      borderRadius: theme.radius.sm,
    },
    '& .ant-skeleton-content .ant-skeleton-paragraph > li': {
      backgroundColor: theme.color.semantic.background.neutral.soft,
      borderRadius: theme.radius.sm,
    },
    '&.ant-skeleton-active .ant-skeleton-header .ant-skeleton-avatar': {
      background: `linear-gradient(90deg, ${theme.color.semantic.background.neutral.soft} 25%, ${theme.color.semantic.background.neutral.subtle} 37%, ${theme.color.semantic.background.neutral.soft} 63%)`,
      backgroundSize: '400% 100%',
    },
    '&.ant-skeleton-active .ant-skeleton-content .ant-skeleton-title': {
      background: `linear-gradient(90deg, ${theme.color.semantic.background.neutral.soft} 25%, ${theme.color.semantic.background.neutral.subtle} 37%, ${theme.color.semantic.background.neutral.soft} 63%)`,
      backgroundSize: '400% 100%',
    },
    '&.ant-skeleton-active .ant-skeleton-content .ant-skeleton-paragraph > li': {
      background: `linear-gradient(90deg, ${theme.color.semantic.background.neutral.soft} 25%, ${theme.color.semantic.background.neutral.subtle} 37%, ${theme.color.semantic.background.neutral.soft} 63%)`,
      backgroundSize: '400% 100%',
    },
  },
}));

const SkeletonBase: React.FC<SkeletonProps> = ({ className = '', ...rest }) => {
  const classes = useStyles();
  return <AntSkeleton {...rest} className={`${classes.skeleton} ${className}`.trim()} />;
};

// Forward antd's compound sub-components (Button/Avatar/Input/Image) so callers
// can use `Skeleton.Button` etc. from the design system rather than antd.
const Skeleton = Object.assign(SkeletonBase, {
  Button: AntSkeleton.Button,
  Avatar: AntSkeleton.Avatar,
  Input: AntSkeleton.Input,
  Image: AntSkeleton.Image,
});

export default Skeleton;
